<script>
    import { mapState,mapActions,mapGetters } from 'vuex';
    import LinksMixin from "../../../author/pagesbuilder/mixins/LinksMixin";
    import {TopbarNavigationMenuConfig} from "../../../author/pagesbuilder/dynamic-components/TopbarNavigationMenuConfig";

    export default {
        name: "NavigationMenuComponent",
        mixins: [LinksMixin],
        data () {
            return {
                isPreview: false,
                componentType: "navigation-menu",
                menuOptionsStatus : []
            }
        },
        computed: {
            ...mapState('topbar',[
                'setVisibleMegamenuData',
                'schoolTopbarData',
                'activeTopbarStatus'
            ]),
            ...mapGetters('user',[
                'isLoggedIn'
            ]),
            ...mapState('user',[
                'unreadInboxMessages'
            ]),
            ...mapState('editingSideform',[
                'sideformEditedNode'
            ]),
            getDefaultMenuItems () {
                let menuItems = [];
                const sectionState = this.findNodeState(this.sectionId);

                if (sectionState && sectionState.isTopbar) { // this should be always true, as long as we are only using them in topbar
                    const sectionTemplateId = sectionState.sectionTemplateId;

                    const configPreset = this.getMenuConfigPresetForTemplate(sectionTemplateId);
                    const topbarStateKey = sectionState.topbarStatus === "logged-out" ? 'loggedOut' : 'loggedIn';

                    const menuComponents = sectionState.nestedComponentIds.map(componentId => this.findNodeState(componentId)).filter(componentState => componentState.componentType === 'navigation-menu');
                    const currentMenuIndex = menuComponents.findIndex(component => component.myId === this.myId);

                    if (configPreset[topbarStateKey].menus[currentMenuIndex]) {
                        menuItems = configPreset[topbarStateKey].menus[currentMenuIndex].menuItems;
                    } else {
                        menuItems = configPreset[topbarStateKey].menus[0].menuItems;
                    }
                }

                return menuItems;
            },
            getDefaultDataStructure () {
                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    template: "navigationMenu1",
                    styles: null,
                    hoverEnabled: true,
                    hoverEffect: "",
                    activeLinkDisplay: true,
                    fontWeight: 0,
                    fontSize: 0,
                    letterSpacing : 0,
                    menuLinksAppearance : "textOnly",
                    menuLinksSize: "",
                    items: this.getDefaultMenuItems,
                    itemVisibilitySettings: null
                }
            },
            buttonLikeAppearanceKeys () {
                return ["roundedSolid","roundedOutline","roundedSolidAccent1","roundedOutlineAccent1","roundedSolidAccent2","roundedOutlineAccent2"];
            },
            hasHamburgerContent () {
               return true; //by default its enabled for nav menus
            },
            getLinkData (id) {
                return (id) => {
                    let linkData = {};
                    let appearance = "";
                    let inHamburger = true;
                    let extraPropsDisplay = false;
                    let buttonRadiusDisplay = false;
                    let selectedButtonRadius = 0;
                    let label = "";

                    if (this.myData.items) {
                        this.myData.items.forEach( item => {
                            if (item.id === id) {
                                linkData = item.linkData ? copyJson(item.linkData) : {};
                                appearance = item.appearance;
                                inHamburger = item.inHamburger;
                                label = item.label;
                                if (this.buttonLikeAppearanceKeys.includes(appearance)) {
                                    buttonRadiusDisplay = true;
                                    selectedButtonRadius = item.borderRadius;
                                }
                                extraPropsDisplay = true;
                            }

                            if (item.subItems) {
                                item.subItems.forEach(subItem => {
                                    if (subItem.id === id && subItem.linkData) {
                                        linkData = copyJson(subItem.linkData);
                                        appearance = subItem.appearance;
                                        label = subItem.label;
                                        if (this.buttonLikeAppearanceKeys.includes(appearance)) {
                                            buttonRadiusDisplay = true;
                                            selectedButtonRadius = subItem.borderRadius;
                                        }
                                        inHamburger = subItem.inHamburger;
                                        extraPropsDisplay = true;
                                    }
                                })
                            }
                        })
                    }

                    linkData = linkData ? linkData: {};

                    linkData.selectedAppearance = appearance;
                    linkData.selectedMenuAppearance = this.getMenuLinksAppearance();
                    linkData.appearanceOptionsDisplay = true;
                    linkData.inHamburger = inHamburger;
                    linkData.buttonDisplayLabel = label;
                    linkData.buttonRadiusDisplay = buttonRadiusDisplay;
                    linkData.selectedButtonRadius = selectedButtonRadius;
                    linkData.extraPropsDisplay = extraPropsDisplay;
                    return linkData;
                }

            },
        },
        methods : {
            ...mapActions('editingSideform',[
                'setSideformDisplay',
                'setVisibleMegamenu'
            ]),
            ...mapActions('topbar',[
                'setVisibleMegamenuData'
            ]),
            getMenuConfigPresetForTemplate (templateId) {
                const foundPreset = Object.keys(TopbarNavigationMenuConfig)
                    .map(key => TopbarNavigationMenuConfig[key])
                    .find(preset => typeof preset.forTopbarTemplates !== 'undefined' && preset.forTopbarTemplates.includes(templateId));
                return foundPreset || TopbarNavigationMenuConfig.default;
            },
            editMenuData (renderData) {
                let isInboxLink = (linkData) => { return linkData.linkType === "appslink" && linkData.linkTo === "inbox" };

                if (renderData.items) {
                    renderData.items.forEach( (item,index) => {
                        if (item.linkData?.linkType) {
                            let itemHref = this.createHrefForLink(item.linkData);

                            if (this.enableHref && itemHref) {
                                item.linkData.href = itemHref;
                            } else {
                                item.linkData.href = "javascript:void(0)";
                                item.linkData.linkOpen = "default";
                            }

                            if (isInboxLink(item.linkData) && this.displayInboxNotifications) {
                                item.notifications = this.unreadInboxMessages;
                            }
                        }

                        if (item.subItems) {
                            item.subItems.forEach( (subItem,subIndex) => {

                                if (subItem.linkData.linkType) {

                                    let subItemHref = this.createHrefForLink(subItem.linkData);

                                    if (this.enableHref && subItemHref) {
                                        subItem.linkData.href = subItemHref;
                                    } else {
                                        subItem.linkData.href = "javascript:void(0)";
                                        subItem.linkData.linkOpen = "default";
                                    }

                                    if (isInboxLink(subItem.linkData) && this.displayInboxNotifications) {
                                        subItem.notifications = this.unreadInboxMessages;
                                    }

                                }

                                if (subItem.type === 'megamenu') {
                                    renderData.items[index].hasMegamenu = true;
                                }
                            })
                        }
                    })
                }

                return renderData;
            },
            renderMenu () {

                let renderData = copyJson(this.myData);
                renderData = this.editMenuData(renderData);
                renderData.isPreview = this.isPreview;
                // this.renderInProgress = true;
                if (!renderData.template) {
                    return;
                }
                this.renderTemplate(renderData.template,renderData).then( output => {
                    this.componentNode.innerHTML = '';
                    this.componentNode.insertAdjacentHTML("beforeend",output);
                    this.renderingCompleted(renderData);
                })
            },
            renderComponent () {
                this.renderMenu();
            },

            getHamburgerContent () {

                let hamburgerOptions = [];

                if (!this.myData.items) {
                    return hamburgerOptions;
                }

                this.myData.items.forEach(item => {

                    if (item.inHamburger) {
                        let hamburgerOptionData = {
                            text: item.label,
                            html: false,
                            id: null,
                            className: this.getItemClassName(item),
                            href: null,
                        }

                        if (item.linkData && item.linkData.linkType && this.linkTypesUsingAnchors.includes(item.linkData.linkType)) {
                            hamburgerOptionData["href"] = this.createHrefForLink(item.linkData)
                        } else if (item.linkData?.linkTo) {
                            hamburgerOptionData['linkData'] = item.linkData;
                        }
                        hamburgerOptions.push(hamburgerOptionData);
                    }

                    if (item.subItems) {
                        item.subItems.forEach(subItem => {
                            if (!subItem.inHamburger) {
                                // skip subItem
                                return;
                            }

                            let hamburgerOptionData = {
                                text: subItem.label,
                                html: false,
                                id: null,
                                className: this.getItemClassName(subItem),
                                href: null,
                            }

                            if (subItem.linkData && subItem.linkData.linkType && this.linkTypesUsingAnchors.includes(subItem.linkData.linkType)) {
                                hamburgerOptionData["href"] = this.createHrefForLink(subItem.linkData)
                            } else if (subItem.linkData?.linkTo) {
                                hamburgerOptionData['linkData'] = item.linkData;
                            }
                            hamburgerOptions.push(hamburgerOptionData);
                        })
                    }
                })

                return hamburgerOptions;
            },
            getItemClassName (item) {
                // mapping using in navigationMenu1.liquid
                const defaultMenuItemClasses = 'lw-brand-text text-only';
                const optionToClassMapping = {
                    'roundedSolid':  'learnworlds-button-solid-brand button-like',
                    'roundedOutline':  'learnworlds-button-outline-brand button-like',
                    'roundedSolidAccent1': 'learnworlds-button-solid-accent1 button-like',
                    'roundedOutlineAccent1': 'learnworlds-button-outline-accent1 button-like',
                    'roundedSolidAccent2': 'learnworlds-button-solid-accent2 button-like',
                    'roundedOutlineAccent2': 'learnworlds-button-outline-accent2 button-like',
                    'textLink': 'text-only lw-link-text',
                    'textOnlyAccent1': 'lw-brand-accent1-text text-only',
                    'textUnderline': 'lw-brand-border border-bottom',
                    'textUnderlineAccent1': 'lw-accent1-border border-bottom',
                    'rectangleSolid': 'learnworlds-button-solid-brand button-like',
                    'rectangleOutline': 'learnworlds-button-outline-brand button-like',
                    'bottomLine': 'bottom-border lw-brand-text',
                    'topLine': 'top-border lw-brand-text',
                };
                
                return optionToClassMapping[item.appearance] || defaultMenuItemClasses;
            },
        },
        watch: {
            "myData.items": {
                handler (newVal,oldVal) {
                    if (newVal !== oldVal) {
                        this.debouncedRenderComponent();
                    }
                }
            },
            "myData.menuLinksAppearance": {
                handler (newVal,oldVal) {
                    if (newVal !== oldVal) {
                        this.debouncedRenderComponent();
                    }
                }
            },
            "myData.menuLinksSize": {
                handler (newVal,oldVal) {
                    if (newVal !== oldVal) {
                        this.debouncedRenderComponent();
                    }
                }
            },
            "myData.hoverEnabled": {
                handler (newVal,oldVal) {
                    if (newVal !== oldVal) {
                        this.debouncedRenderComponent();
                    }
                }
            },
            "myData.template": {
                handler (newVal,oldVal) {
                    if (newVal !== oldVal) {
                        this.debouncedRenderComponent();
                    }
                }
            },
            "myData.fontSize": {
                handler (newVal,oldVal) {
                    if (newVal !== oldVal) {
                        this.debouncedRenderComponent();
                    }
                }
            },
            "myData.fontWeight": {
                handler (newVal,oldVal) {
                    if (newVal !== oldVal) {
                        this.debouncedRenderComponent();
                    }
                }
            },
            "myData.letterSpacing": {
                handler (newVal,oldVal) {
                    if (newVal !== oldVal) {
                        this.debouncedRenderComponent();
                    }
                }
            },
            "myData.hoverEffect": {
                handler (newVal,oldVal) {
                    if (newVal !== oldVal) {
                        this.debouncedRenderComponent();
                    }
                }
            }
        }
    }
</script>
